import { Address } from '@/schema/address';
import { Period } from '@/schema/legal_entity/payment_plan/conditions';
import { Payment_Reference_Type } from '@/schema/legal_entity/processing_details';
import axios from 'axios';

export function legalEntityUpdatePaymentPlanProcessingDetails(
	participant: string,
	legal_entity: string,
	frequency: Period,
	maximum_duration: number,
	payment_reference_type: Payment_Reference_Type
) {
	const payload = {
		participant: participant,
		legal_entity: legal_entity,
		payment_reference_type: payment_reference_type,
		frequency: frequency,
		maximum_duration: maximum_duration
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/operator-fe/update-payment-plan-processing-details`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

export function legalEntityUpdateLogo(
	participant: string,
	legal_entity: string,
	url: string
) {
	const payload = {
		participant: participant,
		legal_entity: legal_entity,
		url: url
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/operator-fe/update-logo`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}

export function legalEntityUpdateAddress(
	participant: string,
	legal_entity: string,
	address: Address
) {
	const payload = {
		participant: participant,
		legal_entity: legal_entity,
		address: address
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/operator-fe/update-address`, payload, {
		headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
	});
}
